export const sessionSet = (data) => {
    sessionStorage.setItem('leadAdditionalParams', JSON.stringify(data));
}

export const sessionGetAndClear = () => {
    const data = sessionStorage.getItem('leadAdditionalParams');
    sessionStorage.removeItem('leadAdditionalParams');
    return JSON.parse(data);
}